import { useStaticQuery, graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";

type SeoProps = {
  description?: string;
  lang?: string;
  meta?: string[];
  keywords?: string[];
  title?: string;
  pathname: string; // on any page, props.location is passed in automatically by gatsby (access via destructuring e.g. {location}). the page should give this component location.pathname
};

const SEO = ({
  description = ``,
  lang = `en`,
  meta = [],
  keywords = [],
  title = ``,
  pathname,
}: SeoProps): any => {
  const { site, defaultImage } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
      defaultImage: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 512) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);

  const ogImageUrl =
    site.siteMetadata.siteUrl + defaultImage.childImageSharp.fixed.src;

  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: ogImageUrl,
        },
        {
          property: `twitter:image`,
          content: ogImageUrl,
        },
        {
          property: `image`,
          content: ogImageUrl,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={[{ rel: "canonical", href: site.siteMetadata.siteUrl + pathname }]}
    />
  );
};

export default SEO;
